export default "__VITE_ASSET__Dz_aGCVN__"